module.exports = __webpack_public_path__ + "img/hint-two-eng.e2ded3ca.jpg";